










































































import { PRODUCT_TYPE_MAP } from '@algolia-search/consts';
import {
  getBundleMinPrice,
  getImageUrl,
  getProductDescription,
  getProductName,
  getProductPrice,
  getProductType,
  getProductUrl,
  hasDynamicPrice,
  mapAlgoliaProductToProduct
} from '@algolia-search/helpers/product';
import type { AlgoliaProduct } from '@algolia-search/types';
import type { PropType } from '@nuxtjs/composition-api';
import {
  computed,
  defineComponent,
  useContext,
  useRouter
} from '@nuxtjs/composition-api';
import { SfPrice } from '@storefront-ui/vue';
import VaimoBanner from 'atoms/VaimoBanner.vue';
import VaimoButton from 'atoms/VaimoButton.vue';

import { useStore } from '~/composables';
import { validateFraction } from '~/diptyqueTheme/helpers/priceFormatter';
import { useAddToCart } from '~/helpers/cart/addToCart';
import { Logger } from '~/helpers/logger';
import type { CurrencyEnum } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'AlgoliaProductSuggestions',
  components: {
    SfPrice,
    VaimoBanner,
    VaimoButton
  },
  props: {
    products: {
      type: Array as PropType<AlgoliaProduct[]>,
      required: true
    }
  },
  emits: ['added-to-cart', 'hit-click'],
  setup(_, { emit }) {
    const { addItemToCart } = useAddToCart();
    const { i18n, localePath } = useContext();
    const router = useRouter();
    const { isJpStore } = useStore();

    const localeCurrency = computed<CurrencyEnum>(
      () => i18n.localeProperties.defaultCurrency || 'EUR'
    );

    const isBundleProduct = (product: AlgoliaProduct): boolean =>
      getProductType(product) === PRODUCT_TYPE_MAP.bundle;

    const getDynamicPriceText = (price: string) => {
      return i18n.t('From {price}', {
        price
      });
    };

    const handleGoToProduct = (product: AlgoliaProduct) => {
      router.push(localePath(getProductUrl(product)));
      handleProductClick(product);
    };

    const handleProductClick = (product: AlgoliaProduct) => {
      emit('hit-click', product);
    };

    const addProductToCart = async (product: AlgoliaProduct) => {
      try {
        const productParams = mapAlgoliaProductToProduct(
          product,
          localeCurrency.value,
          isJpStore.value
        );

        await addItemToCart({ product: productParams, quantity: 1 });

        emit('added-to-cart', product);
      } catch (error) {
        Logger.error('Failed to add product to cart:', error);
      }
    };

    return {
      localeCurrency,
      hasDynamicPrice,
      isBundleProduct,
      getDynamicPriceText,
      getProductName,
      getProductDescription,
      getProductUrl,
      getProductPrice,
      getBundleMinPrice,
      getImageUrl,
      addProductToCart,
      validateFraction,
      handleGoToProduct,
      handleProductClick,
      isJpStore
    };
  }
});
